import { BoardCourier } from "../../components";


export const CouriersModulePage = () => {
    return(
        <BoardCourier/>
    );
}